// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__14zc3","name":"ConsentHeader_name__3DQ3L","birthday":"ConsentHeader_birthday__1PuS3","skeleton":"ConsentHeader_skeleton__1YDcx"};